import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';
import { Flex } from '@chakra-ui/react';

import { Container, Error } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: {};
	type?: string;
	handleOnBlur?: (prop: any) => void;
	iconInputRight?: {
		IconRight: React.ComponentType<IconBaseProps>;
		showPassword: boolean;
		setShowPassword: (show: boolean) => void;
	};
}

const Input: React.FC<InputProps> = ({
  name,
  icon: Icon,
  containerStyle,
	handleOnBlur,
	iconInputRight,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
    >
      {Icon && <Icon />}
			
      <input
        onFocus={handleInputFocus}
        onBlur={(e) => {
					handleInputBlur();
					handleOnBlur && handleOnBlur(e);
				}}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />

			{iconInputRight && (
				<iconInputRight.IconRight
					cursor="pointer"
					onClick={() => {
						iconInputRight.setShowPassword(!iconInputRight.showPassword);

						if (inputRef.current) {
							const inputValueSize = inputRef.current.value.length;
							inputRef.current.setSelectionRange(inputValueSize, inputValueSize);

							setTimeout(() => inputRef.current?.focus(), 200);
						}
					}}
				/>
			)}

      {error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default Input;
